// extracted by mini-css-extract-plugin
export var dataCell = "_op-2";
export var dataRow = "_op-0";
export var headerRow = "_op-1";